import { useEffect, useState, useMemo } from 'react'
import { useGetAppcheck } from 'hooks/useGetAppcheck'

let movieAssistantAccessToken: string | null = localStorage.getItem(
  'movieAssistantAccessToken'
)

export const useGetAuthorizationToken = () => {
  const { appCheckToken } = useGetAppcheck()
  const [accessToken, setAccessToken] = useState<string | null>(
    movieAssistantAccessToken
  )
  const [isFetchingAccessToken, setIsFetchingAccessToken] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const fetchAccessToken = useMemo(
    () => async () => {
      setIsFetchingAccessToken(true)
      setErrorMessage(null)

      if (!appCheckToken) {
        setErrorMessage('No App Check token')
        setIsFetchingAccessToken(false)
        return
      }

      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('X-Firebase-AppCheck', appCheckToken)

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow' as RequestRedirect,
      }

      try {
        const response = await fetch(
          'https://europe-west6-captchadatabases.cloudfunctions.net/movieAssistantAPI/get-access-token',
          requestOptions
        )
        if (response.ok) {
          const accessToken = await response.text()
          movieAssistantAccessToken = accessToken
          window.localStorage.setItem('movieAssistantAccessToken', accessToken)
          setAccessToken(movieAssistantAccessToken)
        } else {
          throw new Error('Failed to fetch access token')
        }
      } catch (error: any) {
        setErrorMessage(error.message || 'An error occurred')
      } finally {
        setIsFetchingAccessToken(false)
      }
    },
    [appCheckToken]
  )

  useEffect(() => {
    if (movieAssistantAccessToken) return
    fetchAccessToken()
  }, [appCheckToken])

  const forceRefresh = async () => {
    await fetchAccessToken()
    return movieAssistantAccessToken
  }

  return {
    accessToken,
    isFetchingAccessToken,
    errorMessage,
    forceRefresh,
  }
}
